import React, { Fragment } from 'react'
import cn from 'classnames'
import Divider from '@ui/Divider'
import Section from '@ui/Section'

export default function Question({
  editable,
  header,
  className,
  topContent = null,
  title,
  description,
  children,
  bottomContent,
  titlePlaceholder,
  descriptionPlaceholder,
  titleTranslationTooltip,
  descriptionTranslationTooltip,
  titleRequired,
  descriptionRequired,
  classNameContent,
  onBlur,
  mode
}) {
  return (
    <div className={cn('question-container', className, mode)}>
      {header && (header.title || header.description) && (
        <Fragment>
          <Section
            size='h3'
            title={header.title}
            description={header.description}
            titlePlaceholder={header.titlePlaceholder}
            descriptionPlaceholder={header.descriptionPlaceholder}
            titleTranslationTooltip={header.titleTranslationTooltip}
            descriptionTranslationTooltip={header.descriptionTranslationTooltip}
            titleRequired={header.titleRequired}
            descriptionRequired={header.descriptionRequired}
            onBlur={header.onBlur}
            editable={editable}
            mode={mode}
            className='question-header'
          />
          <Divider className='big' soft />
        </Fragment>
      )}
      {topContent}
      <Section
        size='h1'
        title={title}
        description={description}
        titlePlaceholder={titlePlaceholder}
        descriptionPlaceholder={descriptionPlaceholder}
        titleTranslationTooltip={titleTranslationTooltip}
        descriptionTranslationTooltip={descriptionTranslationTooltip}
        titleRequired={titleRequired}
        descriptionRequired={descriptionRequired}
        onBlur={onBlur}
        editable={editable}
        className={cn('question-content', classNameContent)}
        mode={mode}
      >
        {children}
      </Section>
      {bottomContent}
    </div>
  )
}
